import React from 'react';
import entities from '../../utils/entities';
import { Button, Row, Col, Container } from 'reactstrap';
import Editor from '../Models/Editor';
import { Route, Switch, useHistory } from 'react-router-dom';
import { FormValue } from '../Form/FormLabel';
import { useAuth } from '../../Services/AuthContext';
import useFetch from '../../Services/useFetch';
import SpecialDocument from '../Editors/SpecialDocument';
import { endpoints } from '../../utils/Constants';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useEdit } from '../../Services/EditContext';
import EditSupplier from '../TabbedEntity/EditSupplier';

const SupplierDetail = ({ index, route, supplier, isClientView, charterRequestId }) => {
    const { id, companyName, companyPhone, email } = supplier ? supplier : {};
    const history = useHistory();
    const [auth] = useAuth();
    const [edit] = useEdit();
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //  <BooleanInput id='shared' label='Shared' />
    const appendCharterRequestId = (url) => charterRequestId ? url + '?charterRequestId=' + encodeURIComponent(charterRequestId) : url;
    const setItemId = (id) => id ? history.push(appendCharterRequestId(route + "/supplier/" + id)) : history.push(route);
    const requirementsUrl = endpoints.getSupplierDocumentRequirements + id + (charterRequestId ? '?charterRequestId=' + encodeURIComponent(charterRequestId) : '');
    const [requirements, loadingSupplierDocs, loadingSupplierDocserror, refresh] = useFetch(id ? requirementsUrl : null);
    const termsDoc = requirements?.find(r => r.code === 'Operator Terms and Conditions')?.document;

    return auth.canViewSupplierInfo || auth.role === 'Admin' ? <React.Fragment>
        {supplier ? isClientView ? <Container>
            <Row>
                <Col >
                    <Button size="sm" color="danger" onClick={() => setItemId(id)}>View Supplier</Button>
                </Col>
                <Switch>
                    {!index ? <Route path={route + '/supplier/:supplierId/:activeKey'} render={({ match }) => <Editor route={route + '/supplier'} entity={entities.supplier} itemId={match.params.supplierId} editorClosed={() => setItemId()}><EditSupplier route={route + '/supplier'} charterRequestId={charterRequestId} /></Editor>} /> : null}
                    {!index ? <Route path={route + '/supplier/:supplierId'} render={({ match }) => <Editor route={route + '/supplier'} entity={entities.supplier} itemId={match.params.supplierId} editorClosed={() => setItemId()}><EditSupplier route={route + '/supplier'} charterRequestId={charterRequestId} /></Editor>} /> : null}
                </Switch>
            </Row>
        </Container> :
            <Container>
                <Row>
                    <Col md='3' xs='3'>
                        <Row>
                            {!isClientView ? <FormValue><Button size="sm" onClick={() => setItemId(id)}>Supplier ({supplier.status})</Button></FormValue> : null}
                        </Row>
                        <Row>
                            <FormValue>{companyName}</FormValue>
                        </Row>
                        <Row>
                            <FormValue>{email}</FormValue>
                        </Row>
                        <Row>
                            <FormValue>{companyPhone}</FormValue>
                        </Row>
                        <Switch>
                            {!index ? <Route path={route + '/supplier/:supplierId/:activeKey'} render={({ match }) => <Editor route={route + '/supplier'} entity={entities.supplier} itemId={match.params.supplierId} editorClosed={() => setItemId()}><EditSupplier route={route + '/supplier'} charterRequestId={charterRequestId} /></Editor>} /> : null}
                            {!index ? <Route path={route + '/supplier/:supplierId'} render={({ match }) => <Editor route={route + '/supplier'} entity={entities.supplier} itemId={match.params.supplierId} editorClosed={() => setItemId()}><EditSupplier route={route + '/supplier'} charterRequestId={charterRequestId} /></Editor>} /> : null}
                        </Switch>
                    </Col>
                    <Col >
                        <Row>
                            {!edit && loadingSupplierDocs ? <LoadingAnimation height={50} /> : null}
                            {!edit && loadingSupplierDocserror ? <h6>Error Loading Supplier Documnts</h6> : null}
                            {!edit && termsDoc && <SpecialDocument key={termsDoc.id} doc={termsDoc} refresh={refresh} supplierId={id} buttonName="Supplier Terms and Conditions" />}
                        </Row>
                    </Col>
                </Row>
            </Container>
            : null}


    </React.Fragment> : null;

};

export default SupplierDetail;